import { Col, Form, InputGroup, Row } from 'react-bootstrap'
import ResultContainer from '../ResultContainer'
import { EndPointProps } from '../APIManager.d'
import { availableSitemapFormat, SitemapFormatType } from '../service'
import { FC, useEffect, useState } from 'react'
import RunButton from '../extras/RunButton'

const SitemapEndpoint: FC<EndPointProps> = ({ apiKey, version }) => {
    const [result, setResult] = useState<object>({})
    const [format, setFormat] = useState<SitemapFormatType>('json')
    const [apiUrl, setApiUrl] = useState<string>('')

    useEffect(() => {
        setApiUrl(
            `${process.env.REACT_APP_CLIENT_API_ROOT}/${version}/sitemap${
                format ? '?format=' + format : ''
            }`
        )
    }, [format, version])

    return (
        <Row>
            <Col xl={12}>
                <InputGroup className="mb-3">
                    <InputGroup.Text className="px-4">GET</InputGroup.Text>
                    <div className="form-control readonly">{apiUrl}</div>
                    <RunButton
                        apiUrl={apiUrl}
                        apiKey={apiKey}
                        setResult={setResult}
                    />
                </InputGroup>
            </Col>
            <Col xl={3} lg={4}>
                <h6>Parameters</h6>
                <Form.Group className="mb-3 sfy-field">
                    <Form.Label className="w-100">Output Format</Form.Label>
                    <Form.Select
                        aria-label="Select output format"
                        value={format}
                        onChange={(e) =>
                            setFormat(e.target.value as SitemapFormatType)
                        }
                    >
                        {Object.values(availableSitemapFormat).map((format) => {
                            return (
                                <option key={format.code} value={format.code}>
                                    {format.label}
                                </option>
                            )
                        })}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col xl={9} lg={8}>
                <ResultContainer result={result} viewType={format} />
            </Col>
        </Row>
    )
}

export default SitemapEndpoint
